import { useSelector } from 'react-redux';
import { useRequest } from 'redux-query-react';
import { UseDataInfo, State } from 'types';

import { stripePublishableKeyQuery } from './paymentsQueries';

export const useStripePublishableKey = (): UseDataInfo<string | undefined> => {
  const [queryState, refresh] = useRequest(stripePublishableKeyQuery());
  const stripePublishableKey = useSelector(
    (state: State) => state.entities.payments?.stripePublishableKey,
  );

  return [stripePublishableKey, queryState, refresh];
};
